import { defineStore } from 'pinia'
import { ref } from 'vue'
import { DEFAULT_LANGUAGE, normalizeLanguage } from '~/locales'
import { LANGUAGE_STORAGE_KEY } from '~/constants/language'

function readStoredLanguage() {
  return normalizeLanguage(localStorage.getItem(LANGUAGE_STORAGE_KEY))
}

export const useLanguageStore = defineStore('language', () => {
  const language = ref(DEFAULT_LANGUAGE)

  function applyLanguage(value) {
    document.documentElement.lang = value
    localStorage.setItem(LANGUAGE_STORAGE_KEY, value)
  }

  function setLanguage(value) {
    const next = normalizeLanguage(value)
    language.value = next
    applyLanguage(next)
  }

  /** Sync store state & DOM from localStorage (browser-only persistence). */
  function hydrateFromStorage() {
    const stored = readStoredLanguage()
    language.value = stored
    applyLanguage(stored)
  }

  return {
    language,
    setLanguage,
    hydrateFromStorage,
  }
})
